import React, { useState, useEffect } from "react";
import { Form, Input, Button, Card } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { login, verifyToken } from './loginApi';
import { useAuth } from "./AuthContext";

const LoginForm = ({ onLoginSuccess, onLoginFail }) => {
  const { setUserData } = useAuth();  // Access the context to set userData

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Check if token exists and is valid
  useEffect(() => {
    const checkToken = async () => {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const { token } = JSON.parse(userData);
        if (token) {
          try {
            await verifyToken();  // Verify token using the API
            onLoginSuccess();  // Token is valid, proceed with success
          } catch (error) {
            onLoginFail();  
          }
        }
      }
    };

    checkToken();
  }, [onLoginSuccess, onLoginFail]);

  const handleSubmit = async (e) => {
    try {
      const response = await login(email, password);
      if (response.data.status) {
        const { access_token, ...rest } = response.data;
        localStorage.setItem('userData', JSON.stringify({ token:access_token, ...rest }));
       await setUserData({ token:access_token, ...rest });  // Save user data and token in context
        onLoginSuccess();  // Proceed with success
      } else {
        setError(response.data.message);
        onLoginFail();  // Proceed with failure
      }
    } catch (err) {
      setError(err);
      onLoginFail();  // Proceed with failure
    }
  };

  return (
    
    <div className="loginSectionBox">
      
      <div className="flex items-center justify-center LoginCardMain bg-gray-100 min-h-screen">
        <Card
          title={
            <div className="flex items-center gap-2 text-lg headerLogin">
              <UserOutlined />
              <span className="headerText">DBS Product Management Tool</span>
            </div>
          }
          className="max-w-xs shadow-lg rounded-2xl LoginCard w-full"
        >
          <Form
            name="login-form"
            layout="vertical"
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please enter your email!",
                },
                {
                  type: "email",
                  message: "Please enter a valid email!",
                },
              ]}
            >
              <Input placeholder="Enter your email" className="login-input"
                onChange={(e) => setEmail(e.target.value)} />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter your password!",
                },
              ]}
            >
              <Input.Password
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="login-input"
              />
            </Form.Item>

            <Form.Item>
              {error && <p style={{ color: 'red' }}>{error}</p>}
              <Button className="LoginButton" type="primary" htmlType="submit" block>
                Login
              </Button>

            </Form.Item>

          </Form>
        </Card>
      </div>
    </div>
  );
};

export default LoginForm;
